// third-party
import { combineReducers } from "redux";
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

// project imports
import configReducer from "./slices/config";
import snackbarReducer from "./slices/snackbar";
import authReducer from "./slices/auth";
import tourReducer from "./slices/tour";
import tabReducer from "./slices/tab";
import paginationReducer from "./slices/pagination";
import filterReducer from "./slices/filter";
import authApi from "features/authentication/services/auth";
import employeesApi from "features/employee/services/employee";
import debtorsApi from "features/debtor/services/debtor";
import applicationApi from "features/application/services/application";
import dictionaryApi from "shared/services/dictionary";
import signatureApi from "features/signature/services/signature";
import contractsApi from "shared/services/contract";
import noticesApi from "features/notice/services/notice";
import attachmentsApi from "features/notice/services/attachments";
import disbursementApi from "features/disbursement/services/disbursements";
import reportApi from "features/compraPkb/services/report";
import organizationsApi from "features/organization/services/organization";
import leadsApi from "features/lead/services/lead";
import additionalContractApi from "features/additionalContract/services/additionalContract";
import analyticalTreeMapApi from "features/analyticalTreeMap/services/analyticalTreeMap";
import analyticalReportApi from "features/analyticalReport/services/analyticalReport";
import factorsApi from "shared/services/factor";
import templateApi from "features/template/services/template";
import notificationApi from "shared/services/notification";

const configPersistConfig = {
  key: 'config',
  storage: storage,
  whiteList: ['config']
}


const reducer = combineReducers({
  auth: authReducer,
  config: persistReducer(configPersistConfig,configReducer ),
  snackbar: snackbarReducer,
  tour: tourReducer,
  tab: tabReducer,
  pagination: paginationReducer,
  filter: filterReducer,
  [authApi.reducerPath]: authApi.reducer,
  [employeesApi.reducerPath]: employeesApi.reducer,
  [debtorsApi.reducerPath]: debtorsApi.reducer,
  [applicationApi.reducerPath]: applicationApi.reducer,
  [dictionaryApi.reducerPath]: dictionaryApi.reducer,
  [signatureApi.reducerPath]: signatureApi.reducer,
  [contractsApi.reducerPath]: contractsApi.reducer,
  [noticesApi.reducerPath]: noticesApi.reducer,
  [attachmentsApi.reducerPath]: attachmentsApi.reducer,
  [disbursementApi.reducerPath]: disbursementApi.reducer,
  [reportApi.reducerPath]: reportApi.reducer,
  [organizationsApi.reducerPath]: organizationsApi.reducer,
  [leadsApi.reducerPath]: leadsApi.reducer,
  [additionalContractApi.reducerPath]: additionalContractApi.reducer,
  [analyticalTreeMapApi.reducerPath]: analyticalTreeMapApi.reducer,
  [analyticalReportApi.reducerPath]: analyticalReportApi.reducer,
  [factorsApi.reducerPath]: factorsApi.reducer,
  [templateApi.reducerPath]: templateApi.reducer,
  [notificationApi.reducerPath]: notificationApi.reducer,
});

export default reducer ;
